<script>
import {
  resolutionReasonsSummaryColor,
  // COLUMN CHART RESPONSIBLE OPTIONS
  table_smallest_Sizes,
  table_smallest_1_Sizes,
  table_smaller_1_Sizes,
  table_smaller_2_Sizes,
  table_smaller_3_Sizes,
  table_medium_1_Sizes,
  table_medium_2_Sizes,
  table_biggerSizes,
} from '../../../../../../../../../shared/helpers/CustomDashboardsHelper.js';
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    sizeX: {
      type: Number,
      required: true,
    },
    sizeY: {
      type: Number,
      required: true,
    },
    display: {
      type: Object,
      required: true,
    },
    dateRange: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    content: {
      type: Number,
      required: true,
    },
    inbox: {
      // Recebe a informação sobre a inbox selecionada
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    shouldReduceFontSize() {
      const smallScreen = this.windowWidth < 1400;
      const smallCell = this.sizeY === 1;
      return smallScreen && smallCell;
    },
    noDataFound() {
      if (!this.data.inboxes_summary) {
        return true;
      }

      return this.data.inboxes_summary.every(inboxItem =>
        inboxItem.resolutions_summary.every(
          resolution => resolution.count === 0
        )
      );
    },
    responsiveSizes() {
      if (this.sizeX === 1) {
        if (this.sizeY === 1 || (this.sizeY === 1 && this.windowWidth >= 1900))
          return table_smallest_1_Sizes;
        if (this.sizeY === 1 || (this.sizeY === 1 && this.windowWidth < 1900))
          return table_smallest_Sizes;
        if (this.sizeY === 1 || this.windowWidth < 1600)
          return table_smaller_1_Sizes;
        if (this.windowWidth < 1920) return table_smaller_2_Sizes;
        return table_smaller_3_Sizes;
      }
      // FULL HD (1920x1080)
      if (window.innerWidth >= 1750) {
        if (this.sizeY > 1) {
          if (this.$windowWidth < 600) return table_medium_1_Sizes;
          if (this.windowWidth < 1100) return table_medium_2_Sizes;
          return table_biggerSizes;
        }
        return table_smaller_2_Sizes;
      }
      // NOTEBOOKS (1600 X 900)
      if (window.innerWidth >= 1400) {
        if (this.sizeY > 1) {
          if (this.windowWidth < 550) return table_smaller_2_Sizes;
          return table_medium_2_Sizes;
        }
        return table_smaller_1_Sizes;
      }

      if (this.sizeY > 1) {
        if (this.windowWidth < 250) {
          const sizes = { ...table_smallest_Sizes, containerPaddingTop: '100' };
          return sizes;
        }
        if (this.windowWidth < 400) return table_smaller_2_Sizes;
        return table_medium_1_Sizes;
      }
      return table_smallest_Sizes;
    },
    translatedResolutionType() {
      return resolutionType => {
        switch (resolutionType) {
          case 'objective_achieved':
            return this.$t(
              'CUSTOM_DASHBOARDS.CONVERSATION_RESOLUTION_REASONS.OBJECTIVE_ACHIEVED'
            );
          case 'objective_not_achieved':
            return this.$t(
              'CUSTOM_DASHBOARDS.CONVERSATION_RESOLUTION_REASONS.OBJECTIVE_NOT_ACHIEVED'
            );
          case 'doubt':
            return this.$t(
              'CUSTOM_DASHBOARDS.CONVERSATION_RESOLUTION_REASONS.DOUBT'
            );
          case 'other':
            return this.$t(
              'CUSTOM_DASHBOARDS.CONVERSATION_RESOLUTION_REASONS.OTHER'
            );
          default:
            return resolutionType;
        }
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
    },
    getBackgroundColor(resolutionType) {
      switch (resolutionType) {
        case 'objective_achieved':
          return resolutionReasonsSummaryColor.objectiveAchieved;
        case 'objective_not_achieved':
          return resolutionReasonsSummaryColor.objectiveNotAchieved;
        case 'doubt':
          return resolutionReasonsSummaryColor.doubt;
        case 'other':
          return resolutionReasonsSummaryColor.other;
        default:
          return ''; // No background color if the resolutionType doesn't match
      }
    },
  },
};
</script>

<template>
  <div class="summary-container">
    <div v-if="noDataFound" class="text-xs">
      {{
        $t('CUSTOM_DASHBOARDS.CONVERSATION_RESOLUTION_REASONS.NO_RESOLUTION')
      }}
    </div>

    <!-- Se nenhuma inbox for especificada, exiba apenas o total -->
    <div
      v-else-if="!inbox.id"
      class="control-section pt-25"
      :style="{ 'padding-top': responsiveSizes.containerPaddingTop }"
    >
      {{ content }}
    </div>

    <!-- Se uma inbox for especificada, exiba a tabela correspondente -->
    <div
      v-else-if="data.inboxes_summary && data.inboxes_summary.length"
      class="pt-4"
      :style="{
        'padding-top': responsiveSizes.containerPaddingTop,
        'padding-bottom': responsiveSizes.containerPaddingBottom,
        width: responsiveSizes.containerWidth,
      }"
    >
      <div
        v-for="inboxItem in data.inboxes_summary"
        :key="inboxItem.inbox_id"
        class="inbox-summary"
      >
        <table
          v-if="
            inboxItem.resolutions_summary &&
            inboxItem.resolutions_summary.length
          "
          class="min-w-full bg-white border border-gray-300"
        >
          <thead>
            <tr :style="{ 'font-size': responsiveSizes.fontSize }">
              <th
                class="py-2 px-4 border border-gray-300 text-left text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{
                  $t('CUSTOM_DASHBOARDS.SUMMARY_COLUMN_TITLES.RESOLUTION_TYPE')
                }}
              </th>
              <th
                class="py-2 px-4 border border-gray-300 text-left text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{ $t('CUSTOM_DASHBOARDS.SUMMARY_COLUMN_TITLES.REASON_TITLE') }}
              </th>
              <th
                class="py-2 px-4 border border-gray-300 text-left text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{ $t('CUSTOM_DASHBOARDS.SUMMARY_COLUMN_TITLES.COUNT') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="resolution in inboxItem.resolutions_summary"
              :key="resolution.id"
              :style="{
                backgroundColor: getBackgroundColor(resolution.resolution_type),
                'font-size': responsiveSizes.fontSize,
              }"
              class="hover:bg-gray-100"
            >
              <td
                class="py-2 px-4 text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{ translatedResolutionType(resolution.resolution_type) }}
              </td>
              <td
                class="py-2 px-4 border border-gray-300 text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{ resolution.reason_title }}
              </td>
              <td
                class="py-2 px-4 border border-gray-300 text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{ resolution.count }}
              </td>
            </tr>
          </tbody>
          <!-- Linha final para o total -->
          <tfoot>
            <tr :style="{ 'font-size': responsiveSizes.fontSize }">
              <!-- Primeira coluna vazia sem bordas e com fundo transparente -->
              <td
                class="py-2 px-4 border-none bg-transparent"
                :style="{ padding: responsiveSizes.cellPadding }"
              />
              <td
                class="py-2 px-4 border border-gray-300 text-right font-bold text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                Total
              </td>
              <td
                class="py-2 px-4 border border-gray-300 text-left font-bold text-slate-800"
                :style="{ padding: responsiveSizes.cellPadding }"
              >
                {{ inboxItem.total_resolutions }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-slate-800 {
  color: #2d3748;
}
.table-container {
  width: 100%;
  overflow-x: auto;
}
.table {
  min-width: 100%;
  border-collapse: collapse;
}
th,
td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}
th {
  background-color: #f4f4f4;
  font-weight: bold;
}
.no-border {
  border: none !important;
  background-color: transparent !important;
}
</style>
